import React from "react";
import CourseList from "../../../components/adm/course/courseFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const CourseListPage = (props) => {
  return <Layout body={<CourseList />} />;
};

CourseListPage.propTypes = {};

export default CourseListPage;
